let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("GRoHb")).then(() => parcelRequire('d41ym'));